// **  Initial State
const initialState = {
  userData: {},
  permisos: undefined
}

const prefix = 'auth'

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${prefix}/LOGIN`:
      return {
        ...state,
        userData: action.data,
        [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName],
        [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case `${prefix}/LOGOUT`:
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, ...obj }
    case `${prefix}/PERMISOS`:
      return { ...state, permisos: action.data }
    default:
      return state
  }
}

export default authReducer
